import { useEffect, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { useArmoryApi } from "../hooks/useArmoryApi";
import { InventoryObjectSku } from "../apis/armoryApi";

interface AssetSKUDropdownProps {
  handleChange: (sku: InventoryObjectSku | null) => void;
  disabled?: boolean;
}
const AssetSKUDropdown: React.FC<AssetSKUDropdownProps> = ({
  handleChange,
  disabled = false,
}) => {
  const { getInventoryObjectSkus } = useArmoryApi();
  const [skuList, setSkuList] = useState<InventoryObjectSku[]>([]);
  const [skuListByType, setSkuListByType] = useState<{
    [key: string]: InventoryObjectSku[];
  }>({});
  const [selectedSku, setSelectedSku] = useState<InventoryObjectSku | null>(
    null
  );

  useEffect(() => {
    const getSKUListAsync = async () => {
      const result = await getInventoryObjectSkus();

      if (result.data) {
        setSkuList(result.data);
      }
    };

    getSKUListAsync();
  }, []);

  useEffect(() => {
    const typeGroup: { [key: string]: InventoryObjectSku[] } = {};

    if (skuList) {
      skuList.forEach((sku) => {
        const key = sku.type;

        if (key) {
          if (typeGroup[key]) {
            typeGroup[key].push(sku);
          } else {
            typeGroup[key] = [sku];
          }
        }
      });
    }

    setSkuListByType(typeGroup);
  }, [skuList]);

  const handleDropdownChange = (option: any) => {
    const newSKU = skuList.find((sku) => sku.id === option);

    if (newSKU) {
      setSelectedSku(newSKU);
      handleChange(newSKU);
    }
  };

  const dropdownOptions = Object.keys(skuListByType)
    .sort()
    .map((type) => ({
      label: type,
      items: skuListByType[type]
        .sort(
          (a, b) =>
            a.make.localeCompare(b.make) || a.model.localeCompare(b.model)
        )
        .map((sku) => ({
          label: `${sku.make} ${sku.model}`,
          value: sku.id,
        })),
    }));

  const optionGroupTemplate = (option: any) => {
    return (
      <div className="flex align-items-center" style={{ fontSize: "16px" }}>
        <span
          className="pi pi-building-columns"
          style={{ paddingInline: "10px" }}
        ></span>
        <div>{option.label}</div>
      </div>
    );
  };

  return (
    <Dropdown
      filter
      filterInputAutoFocus
      filterPlaceholder="Search"
      disabled={disabled}
      options={dropdownOptions}
      optionGroupLabel="label"
      optionGroupChildren="items"
      optionGroupTemplate={optionGroupTemplate}
      optionLabel="label"
      placeholder={"Select a SKU"}
      value={selectedSku?.id}
      onChange={(e) => handleDropdownChange(e.value)}
      title="SKU Select Dropdown"
    />
  );
};

export default AssetSKUDropdown;